module.exports = __webpack_public_path__ + "static/media/nextBg.39196820.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/nextBg.png
// module id = 1826
// module chunks = 0 1